import { render } from "./RatingInput.vue?vue&type=template&id=76a9cb52&scoped=true"
import script from "./RatingInput.vue?vue&type=script&lang=js"
export * from "./RatingInput.vue?vue&type=script&lang=js"

import "./RatingInput.vue?vue&type=style&index=0&id=76a9cb52&scoped=true&lang=css"

import exportComponent from "/home/d6338/zsurvey-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76a9cb52"]])

export default __exports__